import request from "@/utils/request";

// 查询内容管理-全部场景类型列表

export function allListType(query) {
  return request({
    url: "/manage/type/listAll",
    method: "get",
    params: query,
  });
}

// 查询内容管理-场景类型列表
export function listType(query) {
  return request({
    url: "/manage/type/list",
    method: "get",
    params: query,
  });
}

// 查询内容管理-场景类型详细
export function getType(id) {
  return request({
    url: "/manage/type/" + id,
    method: "get",
  });
}

// 新增内容管理-场景类型
export function addType(data) {
  return request({
    url: "/manage/type",
    method: "post",
    data: data,
  });
}

// 修改内容管理-场景类型
export function updateType(data) {
  return request({
    url: "/manage/type",
    method: "put",
    data: data,
  });
}

// 删除内容管理-场景类型
export function delType(id) {
  return request({
    url: "/manage/type/" + id,
    method: "delete",
  });
}
